/* AZ Motorsport — "My Garage" vehicle picker behaviour.
   Extracted verbatim from the inline <script> in snippets/az-garage.liquid so it is
   fetched once and cached, instead of being re-sent as ~25KB of uncacheable markup on
   every page (az-garage renders from layout/theme.liquid, so every template carried it).

   The only Liquid-dependent values are locale / root URL / currency; they arrive on
   window.AZGarageConfig from a one-line <script> in the snippet, immediately before this
   file. Safe to `defer`: the IIFE binds boot() on DOMContentLoaded (or calls it straight
   away when the document is already parsed), and the window.AZGarage render-once guard
   makes a duplicate include a no-op. */
(function(){
  if (window.AZGarage) return; /* render-once guard */

  /* Liquid-injected values (set by the config <script> in snippets/az-garage.liquid).
     Defaults keep the module usable if that tag is ever missing. */
  var AZG_CFG = window.AZGarageConfig || {};

  var IS_FR = !!AZG_CFG.fr;
  var LABELS = {
    myGarage: IS_FR ? 'Mon garage' : 'My Garage',
    change:   IS_FR ? 'Changer de véhicule' : 'Change vehicle',
    remove:   IS_FR ? 'Retirer' : 'Remove',
    selMake:  IS_FR ? 'Marque' : 'Select make',
    selModel: IS_FR ? 'Modèle' : 'Select model',
    selYear:  IS_FR ? 'Année' : 'Select year',
    filter:   IS_FR ? 'Filtrer' : 'Filter',
    check:    IS_FR ? 'Vérifier' : 'Check fitment',
    noParts:  IS_FR ? 'Aucune pièce trouvée pour ce véhicule.' : 'No parts found for this vehicle.',
    loadErr:  IS_FR ? "Impossible de charger les données de véhicules." : 'Could not load vehicle data.'
  };

  /* locale/currency/root injected from Liquid so results links + money are correct in EN & FR */
  var AZ_ROOT = String(AZG_CFG.root || '/').replace(/\/+$/,'');
  var AZ_CURRENCY = AZG_CFG.currency || 'CAD';
  var AZ_LOCALE = IS_FR ? 'fr-CA' : 'en-CA';

  /* ------------------------------------------------------------------ *
   * AZFitment — data layer. Source is swappable (tags today; metafields
   * / vehicle_model metaobjects later) without touching any UI code.
   * ------------------------------------------------------------------ */
  var AZFitment = (function(){
    /* Data source: vehicle_model metaobjects (storefront PUBLIC_READ), fetched once
       from the az-garage-data section (?section_id=az-garage-data) and cached in
       sessionStorage. A section fetch (not inline) is required because
       shop.metaobjects.*.values caps at 50 entries, and an inline paginate loop
       would break on ?page collection URLs (the garage is global); the section
       paginates by 250 on its own clean URL. Exact make/model/year (no
       /products.json 250-cap) + each model's landing collection URL & product
       count for the "view all parts" CTA. */
    var CACHE_KEY = 'az_vm_v1';
    var state = { tree:{}, loaded:false, error:false, queue:[] };

    /* ---- canonicalization: tolerate messy tags (mixed case, hyphens,
       "(chassis)" suffixes, brand-name variants). The SAME rules run on the
       PDP snippet and on stored-vehicle migration, so every layer agrees. ---- */
    var MAKE_ALIASES  = { 'mercedes':'mercedes-benz', 'mercedes benz':'mercedes-benz', 'benz':'mercedes-benz' };
    var MODEL_ALIASES = { 'c8':'corvette c8', 'corvette c8':'corvette c8' }; /* seeded; extend from Phase-B dry-run */
    /* proper display casing for brands/tokens the generic title() gets wrong */
    var DISPLAY = { 'bmw':'BMW','mclaren':'McLaren','mercedes-benz':'Mercedes-Benz','mercedes benz':'Mercedes-Benz','amg':'AMG','gt':'GT','gts':'GTS','gtr':'GTR','gtc':'GTC','rs':'RS','sv':'SV','svj':'SVJ','sto':'STO','evo':'EVO','ff':'FF','tt':'TT','ttrs':'TTRS','gtc4lusso':'GTC4Lusso','mp4-12c':'MP4-12C' };

    function collapseWs(s){ return String(s).replace(/\s+/g,' ').trim(); }
    function uniqPush(arr,v){ if(v && arr.indexOf(v)===-1) arr.push(v); }

    function canonMake(s){
      var v = collapseWs(String(s||'').toLowerCase());
      return MAKE_ALIASES[v] || v;
    }
    /* returns { model:'x5m', chassis:['f95'] } — a trailing "(...)" is pulled
       into chassis so slug (model_x5m) and verbose (Model_X5M (F95)) collapse. */
    function canonModel(s){
      var v = collapseWs(String(s||'').toLowerCase().replace(/-/g,' '));
      var chassis = [];
      var m = v.match(/\(([^)]+)\)\s*$/);
      if (m){ m[1].split(/[\/,]/).forEach(function(c){ uniqPush(chassis, c.replace(/\s+/g,'')); }); v = collapseWs(v.slice(0, m.index)); }
      v = MODEL_ALIASES[v] || v;
      return { model:v, chassis:chassis };
    }

    function title(s){
      var v = collapseWs(String(s||'').replace(/[_-]/g,' '));
      if (DISPLAY[v]) return DISPLAY[v];
      return v.replace(/\S+/g, function(w){
        var lw = w.toLowerCase();
        if (DISPLAY[lw]) return DISPLAY[lw];
        if (/\d/.test(w) || w.length<=3) return w.toUpperCase(); /* codes: x5m, m340i, 911, f90, gt3 */
        return w.charAt(0).toUpperCase()+w.slice(1).toLowerCase();
      });
    }
    /* dropdown label: the metaobject's own model name (already display-cased),
       with a single chassis code appended when unambiguous ("M5 (F90)"). */
    function modelLabel(mk, md){
      var m = (state.tree[mk] && state.tree[mk].models[md]) || null;
      var base = m ? m.label : title(md);
      if (m && m.chassis && m.chassis.length === 1){ base += ' (' + String(m.chassis[0]).toUpperCase() + ')'; }
      return base;
    }

    /* Build make -> {label, models:{ model -> {label, ys, ye, chassis[], cu, cc} }}
       from the metaobject feed. Keys are canonicalized the SAME way as product tags
       (canonModel: hyphen->space + lowercase) so the PDP fit-check still aligns. */
    function buildTree(VM){
      var tree = {};
      (VM || []).forEach(function(e){
        var mk = canonMake(e.make);
        var md = canonModel(e.model).model;
        if (!mk || !md) return;
        if (!tree[mk]) tree[mk] = { label: e.make || title(mk), models: {} };
        var ch = (e.chassis && e.chassis.length) ? e.chassis.slice() : [];
        var ys = parseInt(e.ys, 10) || 0, ye = parseInt(e.ye, 10) || 0;
        var m = tree[mk].models[md];
        if (!m){
          tree[mk].models[md] = { label: e.model || title(md), ys: ys, ye: ye, chassis: ch, cu: e.cu || '', cc: parseInt(e.cc, 10) || 0 };
        } else {
          /* two metaobjects canonicalize to the same key -> widen years, merge chassis, keep a collection */
          if (ys) m.ys = m.ys ? Math.min(m.ys, ys) : ys;
          if (ye) m.ye = Math.max(m.ye, ye);
          ch.forEach(function(c){ if (m.chassis.indexOf(c) === -1) m.chassis.push(c); });
          if (!m.cu && e.cu){ m.cu = e.cu; m.cc = parseInt(e.cc, 10) || 0; }
        }
      });
      state.tree = tree;
    }

    function finishLoad(){
      state.loaded = true;
      var q = state.queue.slice(); state.queue = [];
      q.forEach(function(cb){ try { cb(); } catch(e){} });
    }
    function load(){
      try { var c = sessionStorage.getItem(CACHE_KEY); if (c){ buildTree(JSON.parse(c)); finishLoad(); return; } } catch(e){}
      fetch(AZ_ROOT + '/?section_id=az-garage-data', { headers:{ 'Accept':'text/html' } })
        .then(function(r){ return r.text(); })
        .then(function(html){
          var el = new DOMParser().parseFromString(html, 'text/html').getElementById('az-garage-data-json');
          var arr = el ? JSON.parse(el.textContent) : [];
          try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(arr)); } catch(e){}
          buildTree(arr); finishLoad();
        })
        .catch(function(){ state.error = true; finishLoad(); });
    }

    function yearsFor(mk, md){
      var m = (state.tree[mk] && state.tree[mk].models[md]) || null;
      if (!m || !m.ye) return [];
      var out = [], start = m.ys || m.ye;
      for (var y = m.ye; y >= start; y--) out.push(String(y));
      return out;
    }

    return {
      /* async: first call kicks off the section fetch; subsequent calls fire immediately */
      /* Deferred kickoff. load() hits /?section_id=az-garage-data, which walks every
         vehicle_model metaobject and does a per-row collection product-count lookup
         (sections/az-garage-data.liquid:12-14) — 200-500ms of server work. Firing it
         inline put that in direct competition with the LCP image, and nothing on screen
         waits for it: boot()'s only consumer is a label refresh via notify().
         requestIdleCallback yields until the browser is free, with a 2s timeout so it
         cannot be starved. A real interaction (opening the selector) also routes through
         ready(), so a click landing before idle simply queues on the same request. */
      ready: function(cb){
        if (state.loaded){ try { cb(); } catch(e){} return; }
        state.queue.push(cb);
        if (state.queue.length === 1){
          if (window.requestIdleCallback) window.requestIdleCallback(load, { timeout: 2000 });
          else setTimeout(load, 1200);
        }
      },
      hasError: function(){ return state.error; },
      makes: function(){ return Object.keys(state.tree).sort(); },
      models: function(mk){ var t = state.tree[mk]; return t ? Object.keys(t.models).sort() : []; },
      years: yearsFor,
      title: title,
      modelLabel: modelLabel,
      makeLabelOf: function(mk){ return (state.tree[mk] && state.tree[mk].label) || title(mk); },
      canonMake: canonMake,
      canonModel: canonModel,
      collectionFor: function(mk, md){ var m = (state.tree[mk] && state.tree[mk].models[md]); return (m && m.cu) ? { url: m.cu, count: m.cc } : null; },
      makeHubUrl: function(mk){ return AZ_ROOT + '/collections/' + String(mk || '').replace(/\s+/g, '-'); }
    };
  })();

  /* ------------------------------------------------------------------ *
   * AZGarage — persisted state + UI controllers
   * Multi-vehicle: { vehicles: [vehicle...], active: index }
   * ------------------------------------------------------------------ */
  var STORE_KEY = 'az_garage_v2';
  var LEGACY_KEY = 'az_garage_v1';
  var subs = [];
  var lastFocus = null;
  var pillTimer = null;

  /* Re-canonicalize saved vehicles so garages stored under old/messy values
     (e.g. {make:'mercedes'} or {model:'x5m (f95)'}) keep matching after the
     canonicalization + any later tag cleanup. Idempotent: only writes on change. */
  function migrateVehicles(s){
    if (!s || !Array.isArray(s.vehicles) || !s.vehicles.length) return s;
    var changed=false, seen={}, out=[];
    s.vehicles.forEach(function(v){
      var nv = buildVehicle(v.make, v.model, v.year);
      if (nv.make!==v.make || nv.model!==v.model || nv.label!==v.label) changed = true;
      if (seen[nv.label]){ changed = true; return; } /* drop dupes created by canonicalization */
      seen[nv.label] = true; out.push(nv);
    });
    if (changed){ s.vehicles = out; if (s.active >= out.length) s.active = out.length?0:-1; writeState(s); }
    return s;
  }
  function readState(){
    var s = null;
    try { var raw = JSON.parse(localStorage.getItem(STORE_KEY)); if (raw && Array.isArray(raw.vehicles)) s = raw; } catch(e){}
    if (!s){
      /* migrate single-vehicle v1 */
      try { var old = JSON.parse(localStorage.getItem(LEGACY_KEY)); if (old && old.label){ s = { vehicles:[old], active:0 }; localStorage.removeItem(LEGACY_KEY); } } catch(e){}
    }
    if (!s) return { vehicles:[], active:-1 };
    return migrateVehicles(s);
  }
  function writeState(s){ try { localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch(e){} }
  function activeOf(s){ return (s.active > -1 && s.vehicles[s.active]) ? s.vehicles[s.active] : null; }
  function notify(){ var s = readState(); var a = activeOf(s); subs.forEach(function(cb){ try{cb(a, s);}catch(e){} }); }

  function buildVehicle(make, model, year){
    var mk = make ? AZFitment.canonMake(make) : '';
    var md = model ? AZFitment.canonModel(model).model : '';
    var v = { make:mk, model:md, year:year?String(year):'' };
    v.makeLabel = mk ? AZFitment.makeLabelOf(mk) : '';
    v.modelLabel = md ? AZFitment.modelLabel(mk, md) : ''; /* metaobject display name */
    v.label = [v.makeLabel, v.modelLabel, v.year].filter(Boolean).join(' ');
    /* attach the landing collection (or nothing -> results falls back to the make hub) */
    var info = (mk && md) ? AZFitment.collectionFor(mk, md) : null;
    v.collectionUrl = info ? info.url : '';
    v.collectionCount = info ? info.count : 0;
    return v;
  }

  /* ---- Selector modal ---- */
  var selEl, mkSel, mdSel, yrSel, submitBtn, submitLabel;
  /* "quiet" = opened from the PDP fitment widget: saving the vehicle must leave the
     shopper on the product page (no results modal, no pill) so the widget itself is
     the answer. Reset on submit and on any close so the next opener starts clean. */
  var quietMode = false;
  function setQuiet(on){
    quietMode = !!on;
    if (submitLabel) submitLabel.textContent = quietMode ? LABELS.check : LABELS.filter;
  }
  function fillSelect(sel, items, placeholder){
    sel.innerHTML = '';
    var opt = document.createElement('option'); opt.value=''; opt.textContent=placeholder; sel.appendChild(opt);
    items.forEach(function(it){ var o=document.createElement('option'); o.value=it.value; o.textContent=it.label; sel.appendChild(o); });
  }
  function syncSubmit(){
    /* year is required — except when the selected model has no year data at all
       (placeholder-only select), which must not dead-end the user */
    var needYear = yrSel.options.length > 1;
    submitBtn.disabled = !(mkSel.value && mdSel.value && (!needYear || yrSel.value));
  }
  function initSelector(prefill){
    AZFitment.ready(function(){
      fillSelect(mkSel, AZFitment.makes().map(function(m){return {value:m,label:AZFitment.title(m).toUpperCase()};}), LABELS.selMake);
      mdSel.disabled = true; yrSel.disabled = true; submitBtn.disabled = true;
      fillSelect(mdSel, [], LABELS.selModel); fillSelect(yrSel, [], LABELS.selYear);
      if (prefill && prefill.make){
        mkSel.value = prefill.make; onMake();
        if (prefill.model){ mdSel.value = prefill.model; onModel(); }
        if (prefill.year){ yrSel.value = String(prefill.year); }
        syncSubmit();
      }
    });
  }
  function onMake(){
    var mk = mkSel.value;
    fillSelect(mdSel, AZFitment.models(mk).map(function(m){return {value:m,label:AZFitment.modelLabel(mk,m).toUpperCase()};}), LABELS.selModel);
    fillSelect(yrSel, [], LABELS.selYear);
    mdSel.disabled = !mk; yrSel.disabled = true; syncSubmit();
  }
  function onModel(){
    var mk = mkSel.value, md = mdSel.value;
    fillSelect(yrSel, AZFitment.years(mk,md).map(function(y){return {value:y,label:y};}), LABELS.selYear);
    yrSel.disabled = !md; syncSubmit();
  }

  /* ---- Overlay open/close with focus trap ---- */
  function trap(e, overlay){
    if (e.key === 'Escape'){ close(overlay); return; }
    if (e.key !== 'Tab') return;
    var f = overlay.querySelectorAll('button,select,a[href],input,[tabindex]:not([tabindex="-1"])');
    f = Array.prototype.filter.call(f, function(el){ return !el.disabled && el.offsetParent !== null; });
    if (!f.length) return;
    var first=f[0], last=f[f.length-1];
    if (e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
  }
  function open(overlay){
    lastFocus = document.activeElement;
    overlay.hidden = false;
    /* next frame so the transition runs */
    requestAnimationFrame(function(){ overlay.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    overlay._trap = function(e){ trap(e, overlay); };
    document.addEventListener('keydown', overlay._trap);
    var focusable = overlay.querySelector('select:not(:disabled),button:not(:disabled)');
    if (focusable) setTimeout(function(){ focusable.focus(); }, 60);
  }
  function close(overlay){
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (overlay._trap){ document.removeEventListener('keydown', overlay._trap); overlay._trap=null; }
    setTimeout(function(){
      overlay.hidden = true;
      /* after the fade, so the label does not flicker mid-transition */
      if (overlay === selEl) setQuiet(false);
    }, 300);
    if (lastFocus && lastFocus.focus){ try{ lastFocus.focus(); }catch(e){} }
  }

  /* ---- Results modal ---- */
  var resModal, resGrid, resVeh, resCta;
  function moneyFmt(cents){
    /* products.json prices are decimal strings ("449.00"); fall back gracefully */
    if (cents == null) return '';
    var n = parseFloat(cents);
    if (isNaN(n)) return '';
    try { return new Intl.NumberFormat(AZ_LOCALE,{style:'currency',currency:AZ_CURRENCY}).format(n); }
    catch(e){ return '$'+n.toFixed(2); }
  }
  function renderCard(p){
    var src = (p.images && p.images[0]) ? p.images[0].src : (p.featured_image || null);
    var img = src ? (src + (src.indexOf('?')>-1?'&':'?') + 'width=480') : null;
    var price = (p.variants && p.variants[0]) ? p.variants[0].price : null;
    return '<a class="azg-result" href="'+AZ_ROOT+'/products/'+p.handle+'">'
      + '<span class="azg-result__media">'+(img?'<img loading="lazy" width="240" height="240" src="'+img+'" alt="'+escapeHtml(p.title)+'">':'')+'</span>'
      + '<span class="azg-result__body"><span class="azg-result__title">'+escapeHtml(p.title)+'</span>'
      + '<span class="azg-result__price">'+moneyFmt(price)+'</span></span></a>';
  }
  function ctaHtml(href, primaryLabel){
    return '<a class="azg-btn azg-btn--primary" href="'+href+'">'+primaryLabel+'</a>'
      + '<button type="button" class="azg-btn azg-btn--ghost" data-azg-change>'+LABELS.change+'</button>';
  }
  /* Does this product fit the vehicle? make + model must match, and the vehicle's
     year must be in the product's year_* tags (or the product lists no years).
     This is the SAME rule as the PDP fit widget (az-garage-fit.liquid) so the modal
     and the PDP never disagree. Multi-vehicle parts (several model_/year_ tags) fit
     EVERY vehicle they list and no others — e.g. a 992/2022-2025 part is hidden for a
     2019 GT3, while the 991/2014-2019 part shows. */
  function productFits(p, v){
    if (!v || (!v.make && !v.model)) return true;
    var makes=[], models=[], years=[];
    (p.tags||[]).forEach(function(t){
      t = String(t).toLowerCase().trim();
      if (t.indexOf('make_')===0) makes.push(AZFitment.canonMake(t.slice(5)));
      else if (t.indexOf('model_')===0) models.push(AZFitment.canonModel(t.slice(6)).model);
      else if (t.indexOf('year_')===0) years.push(t.slice(5).trim());
    });
    if (v.make && makes.length && makes.indexOf(v.make)===-1) return false;
    if (v.model && models.length && models.indexOf(v.model)===-1) return false;
    if (v.year && years.length && years.indexOf(String(v.year))===-1) return false;
    return true;
  }
  /* Preview the fitting parts + always give an onward path: the vehicle's landing
     collection (curated + Search&Discovery filters to keep browsing), or the make
     hub when the model has no dedicated collection. */
  function showResults(v){
    resVeh.textContent = v.label;
    resCta.hidden = true; resCta.innerHTML = '';
    resGrid.innerHTML = '';
    for (var i=0;i<6;i++){ var s=document.createElement('div'); s.className='azg-skel'; s.innerHTML='<div class="azg-skel__media"></div><div class="azg-skel__line"></div><div class="azg-skel__line azg-skel__line--short"></div>'; resGrid.appendChild(s); }
    open(resModal);

    /* wrap in ready() so a vehicle restored before the feed loaded still resolves
       its collection (buildVehicle may have run pre-load with an empty collectionUrl) */
    AZFitment.ready(function(){
      var info = (v.make && v.model) ? AZFitment.collectionFor(v.make, v.model) : null;
      var colUrl = info ? info.url : (v.collectionUrl || '');
      var colCount = info ? info.count : (v.collectionCount || 0);

      if (colUrl){
        var base = colUrl.replace(/\/+$/,'');
        /* fetch the whole model collection, then show only the parts that fit THIS
           vehicle's year (year-precise, matches the PDP); the CTA browses the full range */
        fetch(base + '/products.json?limit=250', { headers:{ 'Accept':'application/json' } })
          .then(function(r){ return r.json(); })
          .then(function(j){
            var all = (j.products || []);
            var fitting = all.filter(function(p){ return productFits(p, v); });
            var modelName = [v.makeLabel, v.modelLabel].filter(Boolean).join(' ');
            var total = colCount || all.length;
            if (fitting.length){
              resGrid.innerHTML = fitting.slice(0,6).map(renderCard).join('');
            } else {
              resGrid.innerHTML = stateHtml('empty', IS_FR
                ? ('Aucune pièce ne correspond exactement à votre ' + v.label + '.')
                : ('No parts fit your ' + v.label + ' exactly.'));
            }
            resCta.innerHTML = ctaHtml(colUrl, IS_FR
              ? ('Voir toute la gamme ' + modelName + ' (' + total + ') →')
              : ('Browse all ' + total + ' ' + modelName + ' parts →'));
            resCta.hidden = false;
          })
          .catch(function(){
            resGrid.innerHTML = stateHtml('error', LABELS.loadErr);
            resCta.innerHTML = ctaHtml(colUrl, IS_FR ? 'Voir la collection →' : 'View the collection →');
            resCta.hidden = false;
          });
      } else {
        /* no dedicated model collection -> make hub, with a best-effort model filter */
        var makeName = v.makeLabel || v.make;
        var hub = AZFitment.makeHubUrl(v.make);
        if (v.modelLabel){ hub += '?filter.p.m.azm.models=' + encodeURIComponent(v.modelLabel); }
        resGrid.innerHTML = stateHtml('nohub', IS_FR
          ? ('Pas encore de page dédiée pour ' + v.label + '.')
          : ('No dedicated page for ' + v.label + ' yet.'));
        resCta.innerHTML = ctaHtml(hub, IS_FR ? ('Voir les pièces ' + makeName + ' →') : ('Browse all ' + makeName + ' parts →'));
        resCta.hidden = false;
      }
    });
  }
  function stateHtml(kind, msg){
    /* icon + message only — the onward CTAs live in the footer (resCta) */
    var ico = kind==='error'
      ? '<path d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/>'
      : '<circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>';
    return '<div class="azg-state" style="grid-column:1/-1"><svg class="azg-state__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+ico+'</svg><p class="azg-state__title">'+escapeHtml(msg)+'</p></div>';
  }
  function escapeHtml(s){ return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  /* ---- Confirmation pill ---- */
  var pillEl, pillVeh;
  function showPill(v){
    pillVeh.textContent = v.label;
    pillEl.classList.add('is-open');
    if (pillTimer) clearTimeout(pillTimer);
    pillTimer = setTimeout(function(){ pillEl.classList.remove('is-open'); }, 4500);
  }

  /* ---- Public API ---- */
  window.AZFitment = AZFitment;
  window.AZGarage = {
    /* active vehicle (or null) — same shape as v1 for existing consumers */
    get: function(){ return activeOf(readState()); },
    getAll: function(){ return readState().vehicles.slice(); },
    getState: function(){ return readState(); },
    /* add (or re-activate an identical) vehicle; becomes the active one */
    add: function(v, opts){
      if (!v || !v.label) return;
      var s = readState();
      var idx = -1;
      s.vehicles.forEach(function(x,i){ if (x.label === v.label) idx = i; });
      if (idx === -1){ s.vehicles.push(v); idx = s.vehicles.length - 1; }
      s.active = idx; writeState(s); notify();
      opts = opts || {};
      if (opts.pill !== false) showPill(v);
    },
    setActive: function(i){
      var s = readState();
      if (i > -1 && s.vehicles[i]){ s.active = i; writeState(s); notify(); }
    },
    removeAt: function(i){
      var s = readState();
      if (!(i > -1 && s.vehicles[i])) return;
      s.vehicles.splice(i,1);
      if (s.active === i) s.active = s.vehicles.length ? 0 : -1;
      else if (s.active > i) s.active--;
      writeState(s); notify();
    },
    clear: function(){ writeState({ vehicles:[], active:-1 }); notify(); },
    subscribe: function(cb){ subs.push(cb); return cb; },
    buildVehicle: buildVehicle,
    /* opts.results === false -> stay on the page after saving (PDP fitment widget) */
    openSelector: function(opts){ setQuiet(opts && opts.results === false); initSelector(activeOf(readState())); open(selEl); },
    openResults: showResults
  };
  /* v1 alias: set(v) now adds to the garage */
  window.AZGarage.set = window.AZGarage.add;

  /* ------------------------------------------------------------------ *
   * DOM wiring (runs after full parse; header trigger + sections exist)
   * ------------------------------------------------------------------ */
  function boot(){
    selEl = document.getElementById('azg-selector');
    mkSel = selEl.querySelector('[data-azg-make]');
    mdSel = selEl.querySelector('[data-azg-model]');
    yrSel = selEl.querySelector('[data-azg-year]');
    submitBtn = selEl.querySelector('[data-azg-submit]');
    submitLabel = selEl.querySelector('[data-azg-submit-label]');
    resModal = document.getElementById('azg-results-modal');
    resGrid = resModal.querySelector('[data-azg-results]');
    resVeh = resModal.querySelector('[data-azg-results-veh]');
    resCta = resModal.querySelector('[data-azg-results-cta]');
    pillEl = document.querySelector('[data-azg-pill]');
    pillVeh = pillEl.querySelector('[data-azg-pill-veh]');

    /* "Change vehicle" CTA (delegated; injected into the grid state or the footer) */
    function onChangeClick(e){
      var chg = e.target && e.target.closest ? e.target.closest('[data-azg-change]') : null;
      if (chg){ e.preventDefault(); close(resModal); setTimeout(function(){ window.AZGarage.openSelector(); }, 260); }
    }
    resGrid.addEventListener('click', onChangeClick);
    resCta.addEventListener('click', onChangeClick);

    mkSel.addEventListener('change', onMake);
    mdSel.addEventListener('change', onModel);
    yrSel.addEventListener('change', syncSubmit);

    selEl.querySelector('[data-azg-form]').addEventListener('submit', function(e){
      e.preventDefault();
      var needYear = yrSel.options.length > 1;
      if (!(mkSel.value && mdSel.value && (!needYear || yrSel.value))) return;
      var v = buildVehicle(mkSel.value, mdSel.value, yrSel.value);
      var quiet = quietMode;
      /* quiet: no pill either — the fitment widget re-renders in place with the verdict */
      window.AZGarage.set(v, { pill: !quiet });
      close(selEl);
      if (!quiet) setTimeout(function(){ showResults(v); }, 260);
    });

    /* overlay: click backdrop + [data-azg-close] closes */
    [selEl, resModal].forEach(function(ov){
      ov.addEventListener('click', function(e){ if (e.target === ov) close(ov); });
    });
    document.querySelectorAll('[data-azg-close]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var ov = btn.closest('.azg-overlay');
        if (ov){ close(ov); } else { pillEl.classList.remove('is-open'); }
      });
    });

    /* start loading the vehicle feed now; re-render trigger/fit widgets once ready
       (labels + collection links fill in for any vehicle restored before load) */
    AZFitment.ready(function(){ notify(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
